// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-row-move[data-v-c9be0d5a]{transition:transform 1s}", ""]);
// Exports
module.exports = exports;
